/**
 * List all file extensions possible for file exports
 */
export enum FileExtension {
  CSV = "csv",
  TEXT = "txt"
}
